import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { ref, onMounted } from 'vue';
import { RaCheckbox, RaCheckboxGroup } from '@rafter/pc';
import { settings } from '@/store/settings';
import { searchEngines } from '@/store/searchEngines';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchEngine',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(RaCheckboxGroup), {
      modelValue: _unref(settings).searchEngines,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).searchEngines) = $event)),
      class: "search-check"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchEngines).list, (item) => {
          return (_openBlock(), _createBlock(_unref(RaCheckbox), {
            label: item.value,
            key: item.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "icon",
                style: _normalizeStyle({ backgroundImage: `url(${item.icon})` })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})